import React from "react";
import SimpleTabs from "./CalendarTabs.jsx";

const Usage = props => {
  return (
    <div>
      <SimpleTabs />
    </div>
  );
};

export default Usage;
